import { Route, AppId, createPageRoute } from '@lumapps/router';

export const platformGroupsRoute: Route = createPageRoute({
    slug: 'platform/groups',
    appId: AppId.backOffice,
});
